import { fetcher } from '@common/utils/fetcher';

export type AccountFeature = 'matchmaker' | 'superlike';

export type AccountFeatures = Record<AccountFeature, boolean>;

export type AccountSearch = {
  age_from: number | null;
  age_to: number | null;
};

export type Account = {
  dating: boolean;
  matchmaker: boolean;
  hidden: boolean;
  allow_recommend: boolean;
  search: AccountSearch;
  features: AccountFeatures;
};

export const ACCOUNT_ERROR_CODES = {
  invalidSettings: 'invalid_settings',
  profileIncomplete: 'profile_incomplete',
  featureDisabled: 'feature_disabled',
  notDating: 'not_dating',
} as const;

export const ACCOUNT_SETTINGS_REFUSALS = {
  oneModeRequired: 'one_mode_required',
} as const;

export type GetMeSettingsResponse = Account;

export type PatchMeSettingsParams = Partial<
  Pick<Account, 'dating' | 'matchmaker' | 'hidden' | 'allow_recommend'>
> & {
  search?: Partial<AccountSearch> | null;
};

export type PatchMeSettingsResponse = Account;

export const getMeSettings = () => {
  return fetcher<GetMeSettingsResponse>({
    url: '/me/settings',
    method: 'GET',
  });
};

export const patchMeSettings = (data: PatchMeSettingsParams) => {
  return fetcher<PatchMeSettingsResponse>({
    url: '/me/settings',
    method: 'PATCH',
    data,
  });
};
